import { Box, Text } from 'ink';
import type { Build } from '@todesktop/shared';

export default function Header({
  build,
  name,
  version,
}: {
  build?: Build;
  name: string;
  version?: string;
}) {
  return <Box marginBottom={1}>{getText(build, name, version)}</Box>;
}

function getText(build: Build | undefined, name: string, version?: string) {
  const suffix = name + (version ? ` v${version}` : '');

  if (build && ['cancelled', 'succeeded', 'failed'].includes(build.status)) {
    if (build.status === 'succeeded') {
      return <Text>✅ {suffix}</Text>;
    } else if (build.status === 'failed') {
      return <Text>❌ {suffix}</Text>;
    } else if (build.status === 'cancelled') {
      return (
        <Text>
          <Text bold color="gray">
            X
          </Text>{' '}
          {suffix}
        </Text>
      );
    }
  } else {
    return <Text>{suffix}</Text>;
  }
}
